export default __webpack_public_path__ + "static/johannes-cd780718480d49b5e9df4b31e479bc0d.jpg";